import React from 'react';
import { useTranslation } from 'react-i18next';

const STYLES = {
  DESCENDING: { bg: '#ede9fe', fg: '#5b21b6', border: '#c4b5fd', icon: '↓' },
  ASCENDING:  { bg: '#fce7f3', fg: '#9d174d', border: '#f9a8d4', icon: '↑' },
};

const KEYS = {
  DESCENDING: 'compliance.materiovigilance.flow.descending',
  ASCENDING:  'compliance.materiovigilance.flow.ascending',
};

const MaterioFlowBadge = ({ flowKind }) => {
  const { t } = useTranslation();
  if (!flowKind) return null;
  const c = STYLES[flowKind] || STYLES.DESCENDING;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '2px 10px',
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 600,
        background: c.bg,
        color: c.fg,
        border: `1px solid ${c.border}`,
        whiteSpace: 'nowrap',
      }}
    >
      <span aria-hidden="true">{c.icon}</span>
      {t(KEYS[flowKind] || flowKind, flowKind)}
    </span>
  );
};

export default MaterioFlowBadge;
